// AUTO-GENERATED from config/employee-unit.json by scripts/generate-employee-unit.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-employee-unit.mjs` to regenerate; CI fails on drift.
// Two byte-identical copies, because neither tree may import the other: src/config/employeeUnit.generated.ts
// (the app) and functions/src/billing/employeeUnit.generated.ts (the server).
//
// One Prest0n employee: the work units a month that buy the finished work of an average employee's productive
// month (docs/PLAN-per-employee-pricing-20261030.md). The schedule only rises; a founding subscription receives
// each new row, a later one keeps the row in force on its signing day.

export const EMPLOYEE_UNIT_NAME = "Prest0n employee";
export const EMPLOYEE_UNIT_PLURAL = "Prest0n employees";
/** pr0 a month in one Prest0n employee at launch: the unit every edition-2026-11 tier is priced in. */
export const PR0_PER_EMPLOYEE = 450;
/** About this many hours of finished work a month, at the ROI dataset's hours per rate-card item. */
export const HOURS_OF_FINISHED_WORK_PER_EMPLOYEE = 73;

export interface AllocationStep {
  /** The first day (UTC) this many pr0 per Prest0n employee applies. */
  effectiveOn: string;
  pr0PerEmployee: number;
}

/** The dated schedule of pr0 per Prest0n employee a month: in date order, never falling. */
export const ALLOCATION_SCHEDULE: readonly AllocationStep[] = [
  { effectiveOn: "2026-11-01", pr0PerEmployee: 450 },
];

/** The share of each measured efficiency gain that passes through as more work units. */
export const DIVIDEND_PASS_THROUGH_SHARE = 0.5;
/** New schedule rows are whole multiples of this. */
export const DIVIDEND_ROUND_TO = 5;
/** The founding window's last day (UTC, inclusive), or null while the limited-time offer is open with no day set. */
export const FOUNDING_WINDOW_ENDS_ON: string | null = null;
/** The day the closing day was posted (at least 30 days before it), or null while none is set. */
export const FOUNDING_WINDOW_ENDS_SET_ON: string | null = null;
/** The most Prest0n employees one organization can hire on its own; from BY_MEETING_FROM it books a meeting. */
export const SELF_SERVE_MAX_EMPLOYEES = 299;
export const BY_MEETING_FROM = 300;
/** The day today's published prices took effect (every "prices as of" line reads this). */
export const PRICES_AS_OF = "2026-11-01";

/** The UTC day (YYYY-MM-DD) of an ISO day or timestamp, epoch milliseconds, or a Date; null when unreadable. */
export function isoDay(at: string | number | Date): string | null {
  if (typeof at === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(at)) return at;
  const d = at instanceof Date ? at : new Date(at);
  const ms = d.getTime();
  return Number.isFinite(ms) ? new Date(ms).toISOString().slice(0, 10) : null;
}

/**
 * pr0 per Prest0n employee a month in force on a day: the last schedule row on or before it. Before the first row
 * (and for an unreadable day) the launch row, so a value is never lower than the unit.
 */
export function employeeAllocationOn(at: string | number | Date): number {
  const day = isoDay(at);
  let value = ALLOCATION_SCHEDULE[0].pr0PerEmployee;
  if (!day) return value;
  for (const step of ALLOCATION_SCHEDULE) {
    if (step.effectiveOn <= day) value = step.pr0PerEmployee;
  }
  return value;
}

/** Whether an Order signed on this day is a founding one: the window has no closing day yet, or the day is on or before it. */
export function foundingOpenOn(at: string | number | Date): boolean {
  if (FOUNDING_WINDOW_ENDS_ON === null) return true;
  const day = isoDay(at);
  return day !== null && day <= FOUNDING_WINDOW_ENDS_ON;
}

/**
 * pr0 per seat a month for a subscription priced in this unit: a founding one follows the schedule for the month the
 * work units are for; a later one keeps the row in force on its signing day, for as long as it stays active.
 */
export function allocationPerEmployeeFor(o: { founding: boolean; signedOn: string | number | Date; monthOf: string | number | Date }): number {
  return o.founding ? employeeAllocationOn(o.monthOf) : employeeAllocationOn(o.signedOn);
}
